import { render, staticRenderFns } from "./ProjectDefinitionMgmtView.vue?vue&type=template&id=40c8dc62"
import script from "./ProjectDefinitionMgmtView.vue?vue&type=script&lang=js"
export * from "./ProjectDefinitionMgmtView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports